import { useEffect, useState } from "react";
import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import WorkCenterGroupModal from "../components/WorkCenterGroupModal";
import { listWorkCenterGroupsPaged, deleteWorkCenterGroup } from "../api/workCenterGroups";
import { EmptyState, PageHeader, StatusBadge } from "../components/ui";

function WorkCenterGroups() {
  const [list, setList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total, setTotal] = useState(0);

  function load() {
    listWorkCenterGroupsPaged({ includeInactive: true, page: page + 1, limit: rowsPerPage })
      .then((data) => {
        setList(data?.items || []);
        setTotal(Number(data?.total || 0));
      })
      .catch((err) => {
        console.error("WORK CENTER GROUPS LOAD ERROR", err);
        alert("Makine grupları yüklenemedi");
        setList([]);
        setTotal(0);
      });
  }

  useEffect(() => {
    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  function remove(id) {
    if (!window.confirm("Silmek istiyor musun?")) return;
    deleteWorkCenterGroup(id)
      .then(() => load())
      .catch((err) => {
        console.error("WORK CENTER GROUP DELETE ERROR", err);
        alert("Silinemedi");
      });
  }

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Makine Grupları"
        subtitle="Aynı operasyonu yapabilen makineleri gruplara atayın."
        actions={
          <Button
            variant="contained"
            onClick={() => {
              setSelected(null);
              setModalOpen(true);
            }}
          >
            + Yeni Makine Grubu
          </Button>
        }
      />

      {!list.length ? (
        <EmptyState description="Henüz makine grubu yok." actionLabel="+ Yeni Makine Grubu" onAction={() => setModalOpen(true)} />
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Kod</TableCell>
                <TableCell>Ad</TableCell>
                <TableCell>Tip</TableCell>
                <TableCell>Durum</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((x) => (
                <TableRow key={x.id} hover>
                  <TableCell>
                    <Typography sx={{ fontWeight: 800 }}>{x.code}</Typography>
                  </TableCell>
                  <TableCell>{x.name}</TableCell>
                  <TableCell>{x.type || "—"}</TableCell>
                  <TableCell>
                    <StatusBadge value={x.status || "—"} />
                  </TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          setSelected(x);
                          setModalOpen(true);
                        }}
                      >
                        Düzenle
                      </Button>
                      <Button size="small" color="error" variant="outlined" onClick={() => remove(x.id)}>
                        Sil
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setPage(0);
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            labelRowsPerPage="Sayfa başına kayıt"
          />
        </Paper>
      )}

      {modalOpen ? (
        <WorkCenterGroupModal
          data={selected}
          onClose={() => setModalOpen(false)}
          onSaved={() => load()}
        />
      ) : null}
    </Stack>
  );
}

export default WorkCenterGroups;
